import { render } from "./PhoneNumberVerificationModal.vue?vue&type=template&id=2951a932&scoped=true&ts=true&lang=pug"
import script from "./PhoneNumberVerificationModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhoneNumberVerificationModal.vue?vue&type=script&lang=ts&setup=true"

import "./PhoneNumberVerificationModal.vue?vue&type=style&index=0&id=2951a932&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2951a932"]])

export default __exports__